export default "__VITE_ASSET__Bio8g$Wb__"